import React from "react";

export const AthleteStatsHeader = ({ athleteStatsHeaders }) => {
  return (
    <div className="athlete-stats-header">
      <span className="row-header-label">Stats</span>
      {athleteStatsHeaders.map((stat, index) => (
        <span key={`stat-${index}`} className="row-header">
          {stat}
        </span>
      ))}
    </div>
  );
};
